import React from "react";
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Row, Col, Button, Icon, Menu, Popover } from 'antd';
import AppDatasBody from '../util/AppDatasBody';
import Navigation from '../public/navigation';
import ApplyApp from '../util/appApply/index';

const store = ['caseListStore', 'homeStore'];

@inject(...store)
@observer
class App extends React.Component {

  static defaultProps = {
    prefixCls: 'app-case'
  }

  constructor(props) {
    super(props);
  }

  onNavClick = (item) => {
    const { caseListStore: { routing }, homeStore: { type } } = this.props;
    if (item.key === '1') routing.push('/');
    else if (item.key === '2') {
      routing.push({
        pathname: item.path,
        query: {
          id: toJS(type).id,
        }
      })
    }
  }

  render() {
    const navs = [
      { key: '1', breadcrumbName: '云商店', path: '/' },
      { key: '2', breadcrumbName: '开发案例', path: '/app' },
      { key: '3', breadcrumbName: '详情', path: '/' },
    ];
    const { location, prefixCls } = this.props;
    return (
      <div className={prefixCls}>
        <AppDatasBody location={location}>
          <Navigation datas={navs} onClick={this.onNavClick} />
          <div className={`${prefixCls}-body`}>
            <Row className={`${prefixCls}-body-top`}>
              <Col span={24}><span className={`${prefixCls}-title`}>标题：</span><span>流程表单加载提示</span></Col>
              <Col span={24}><span className={`${prefixCls}-title`}>简介：</span><span>如何为流程表单加载提示?</span></Col>
              <Col span={24}>
                <span className={`${prefixCls}-title`}>操作：</span>
                <span className={`${prefixCls}-title-introduce`}><Icon type="cloud-download" />点击介绍</span>
                </Col>
            </Row>
            <div className={`${prefixCls}-body-bottom`}>
              <div className={`${prefixCls}-particulars`}><span className={`${prefixCls}-title`}>详情：</span></div>
              <div className={`${prefixCls}-content`}>
                
              </div>
            </div>
          </div>
        </AppDatasBody>
      </div>
    )
  }

}

export default App;


// WEBPACK FOOTER //
// ./src/components/case/particulars.js